import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

export function useAppointmentsToConfirm({ startDate, endDate, professionalId }) {
  const navigate = useNavigate();

  const [appointments, setAppointments] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAppointments = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/appointments/to-confirm', {
        params: {
          startDate: startDate.format('YYYY-MM-DD'),
          endDate: endDate.format('YYYY-MM-DD'),
          dentistId: professionalId,
        },
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .then((returnFromApi) => setAppointments(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [startDate, endDate, professionalId, navigate]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  return { appointments, isLoading, error, refetch: fetchAppointments };
}
